import { QTD_DEPENDENTES_ENUM, retornaLabelDoValorParentesco, validatorParentescoEmDuplicidade, verificaConflitoRegrasPaisPadastros } from '../helpers/funcoesPadroes';
import { validarCategoria, validarLimiteCategoria } from './funcoesAuxiliaresZCL';

export class CorrenteCadastroEdicaoZCL {
    constructor(
        dependentes,
        valoresForm,
        parentesco,
        subGrupoSelecionadoUpSell
    ) {
        this.valoresForm = valoresForm;
        this.parentesco = parentesco;
        this.maximoDepSemValorAdicional = QTD_DEPENDENTES_ENUM.sete;
        this.dependentesExistentes = dependentes?.length;
        this.arrayMsgsErro = [];
        this.subGrupoSelecionadoUpSell = subGrupoSelecionadoUpSell;

        if (subGrupoSelecionadoUpSell) {
            this.dependentes = dependentes.filter(dependente => dependente.Status === true);
        } else {
            this.dependentes = dependentes;
        }
    }

    parentescoEmDuplicidade() {
        if (validatorParentescoEmDuplicidade(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro = [`${retornaLabelDoValorParentesco(this.parentesco)}`];
        }

        return this;
    }

    validarCategoriasPlano() {
        const resultValidacao = validarLimiteCategoria(this.dependentes, this.valoresForm);

        if (resultValidacao) {
            this.arrayMsgsErro.push('');
            this.arrayMsgsErro.push(resultValidacao);
        }

        return this;
    }

    validarIdadeCategoria() {
        if (this.valoresForm.Categoria !== 'ZELO') {
            const resultValidacao = validarCategoria(this.valoresForm);

            if (resultValidacao.status) {
                this.arrayMsgsErro.push(resultValidacao.msg);
            }
        }

        return this;
    }

    verificaRepeticaoPaisPadastros() {
        const parentesEmConflito = verificaConflitoRegrasPaisPadastros(this.dependentes, this.valoresForm);

        if (parentesEmConflito) {
            this.arrayMsgsErro.push(parentesEmConflito);
        }

        return this;
    }
}